/**
 * 获取最大最小日期时从validProps中获取；其他属性从props中获取
 */
import React from 'react';
import { View, SectionList, StyleSheet } from 'react-native';
import { commonUtil } from '@qnpm/q-design-utils';
import BaseCalendar from './BaseCalendar';
import WeekHeader from './WeekHeader';
import FakeDayText from './FakeDayText';
import MonthContent from './MonthContent';
import MonthHeader from './MonthHeader';
import { convertSectionCalendarData } from '../../utils/handle';
import SectionListGetItemLayout from '../SectionListGetItemLayout';
export default class SectionCalendar extends BaseCalendar {
    constructor(props) {
        super(props, 'section');
        this.onListLayout = () => {
            this.showLimitMessage();
        };
        /**
         * 渲染月份内容
         * @param item
         * @param rowID
         */
        this.renderItem = (item, rowID) => {
            const { selectedDate, showToolTipMonth, selectedSameDay, startTime, endTime, allowDates, denyDates } = this.state;
            const { showUnderMonth, dayScale, mode, dataSource, accessibilityPreName, denyWeeks } = this.props;
            const { monthKey } = item;
            const canShowToolTip = showToolTipMonth === monthKey;
            return (<MonthContent key={rowID} rowID={rowID} year={item.year} month={item.month} dataSource={item.data[0]} startTime={startTime} endTime={endTime} allowDates={allowDates} denyDates={denyDates} denyWeeks={denyWeeks} mode={mode} dataConfig={dataSource} canShowToolTip={canShowToolTip} showUnderMonth={showUnderMonth} selectedSameDay={selectedSameDay} selectedDate={selectedDate} onSelect={this.updateState} dayScale={dayScale} computedStyle={this.computedStyle} needScale={this.needScale} accessibilityPreName={accessibilityPreName}/>);
        };
        const { monthHeader, dayItem } = this.calendarLayout;
        // 计算子元素布局
        this.getItemLayout = SectionListGetItemLayout({
            getItemHeight: (_, sectionIndex) => sectionIndex === 0
                ? monthHeader.height +
                    dayItem.height +
                    monthHeader.marginBottom
                : dayItem.height,
            getSectionHeaderHeight: () => monthHeader.height
        });
    }
    componentDidMount() {
        const { initScrollDuration } = this.props;
        super.componentDidMount();
        // 滚动到选中位置
        setTimeout(() => {
            // 如果手动滚动过，则不再自动定位
            !this.hasScrolled && this.scrollToPosition(0, this.offset);
        }, initScrollDuration);
    }
    render() {
        const { initialNumToRender, selectedPayload, stickyHeader } = this.props;
        return (<>
                
                {commonUtil.isValidArray(selectedPayload) ? (<FakeDayText data={selectedPayload} computedStyle={this.computedStyle}/>) : null}
                <View style={styles.wrapper}>
                    <WeekHeader data={this.weekHeaderData} computedStyle={this.computedStyle}/>
                    <SectionList onLayout={this.onListLayout} stickySectionHeadersEnabled={stickyHeader} sections={this.renderCalendarData} ref={(ref) => {
            this.scrollRef = ref;
            this.getScrollRef(ref);
        }} initialNumToRender={initialNumToRender} renderItem={({ section }) => this.renderItem(section, section.index)} renderSectionHeader={({ section }) => this.renderSectionHeader(section)} keyExtractor={(_, index) => index.toString()} getItemLayout={this.getItemLayout} 
        // @ts-ignore
        getScrollResponder={this.getScrollResponder} onScroll={this.onScroll}/>
                </View>
            </>);
    }
    /**
     * 渲染月份头部
     * @param section
     */
    renderSectionHeader(section) {
        const { monthHeaderConfig = {}, accessibilityPreName, mode } = this.props;
        const { monthKey } = section;
        return (<MonthHeader title={section.title} config={monthHeaderConfig[monthKey]} computedStyle={this.computedStyle} accessibilityPreName={accessibilityPreName} mode={mode}/>);
    }
    /**
     * 转换section渲染数据
     */
    get renderCalendarData() {
        const { calendarData } = this.state;
        return convertSectionCalendarData(calendarData);
    }
}
const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
        backgroundColor: '#FFFFFF'
    }
});
